export interface Module {
  title: string
  body: string
  /** Spine color of the matching book in the box-set mockup */
  color: string
}

export const modules: Module[] = [
  {
    title: 'MODULE 1 — ADVANCED PATIENT ASSESSMENT & CLINICAL MONITORING',
    body: 'Explore head-to-toe assessments, cardiovascular and respiratory evaluation, neurological examination, vital sign interpretation, clinical deterioration recognition, and patient monitoring through anatomical diagrams, assessment charts, and professional documentation tools.',
    color: 'rgb(var(--color-module-1))',
  },
  {
    title: 'MODULE 2 — INJECTIONS, IV THERAPY & VASCULAR ACCESS',
    body: 'Review injection sites, venous anatomy, peripheral IV devices, infusion equipment, catheter maintenance, vascular access monitoring, and complication recognition through illustrated references, equipment comparisons, and clinical safety checklists.',
    color: 'rgb(var(--color-module-2))',
  },
  {
    title: 'MODULE 3 — ADVANCED WOUND CARE & INFECTION PREVENTION',
    body: 'Identify wound characteristics, compare tissue types, understand healing progression, explore dressing categories, recognize infection warning signs, and organize wound documentation with detailed visual references and assessment tools.',
    color: 'rgb(var(--color-module-3))',
  },
  {
    title: 'MODULE 4 — MEDICATION ADMINISTRATION & PATIENT SAFETY',
    body: 'Explore medication verification, administration routes, dosage calculation checks, high-alert medication precautions, adverse reaction recognition, and error prevention through structured workflows, safety matrices, and practical verification worksheets.',
    color: 'rgb(var(--color-module-4))',
  },
  {
    title: 'MODULE 5 — ESSENTIAL BEDSIDE PROCEDURES & PATIENT CARE',
    body: 'Access visual references for oxygen therapy, airway equipment, enteral feeding, urinary catheters, patient positioning, postoperative monitoring, surgical drains, and bedside care through equipment guides and professional checklists.',
    color: 'rgb(var(--color-module-5))',
  },
  {
    title: 'MODULE 6 — EMERGENCY NURSING & CLINICAL DECISION SUPPORT',
    body: 'Recognize clinical deterioration, review ABCDE assessment, identify emergency warning signs, explore cardiac and respiratory emergencies, understand rapid response workflows, and organize emergency communication with structured visual references.',
    color: 'rgb(var(--color-module-6))',
  },
]
